import { FGSelectInput, FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";

import { ERequestState } from "../../../../api";
import { FGCountrySelect, FGSRSHDateMaskInput } from "../../../../components";
import { useAuth } from "../../../../contexts";
import { useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";
import { DrupalStepperButtonBloc } from "../../../common";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";

export interface IDrupalWorkAttestRequestFormProps {
  workAttestRequestId: number;
  initialdata: any;
  loading: boolean;
}

export const DrupalWorkAttestRequestForm: React.FunctionComponent<IDrupalWorkAttestRequestFormProps> = ({
  loading,
  initialdata,
}) => {
  const { t } = useTl();
  const { user } = useAuth();

  const [dogs, dloading] = useReferential(
    (c) => c.getOwnedDogs(user.userId, initialdata?.dogId ? initialdata.dogId : 0, null, null, null),
    true,
    [initialdata, user]
  );

  return (
    <>
      <DrupalFormGenerator
        initialValues={initialdata}
        editMode={false}
        onSubmit={() => {}}
        loading={loading}
        saving={false}
        deleting={false}
        hideButtons
      >
        <FieldGroup columns={2} fieldsetProps={{ divider: false, title: t(ETLCodes.RequestData) }}>
          <div>
            <FGSRSHDateMaskInput name="request.requestDate" label={t(ETLCodes.RequestDate)} />
            {initialdata?.request?.status === ERequestState.EXECUTED && (
              <FieldGroup columns={2}>
                <FGSRSHDateMaskInput name="request.executionDate" label={t(ETLCodes.ClosingDate)} />
              </FieldGroup>
            )}
            <FGSelectInput name="dogId" label={t(ETLCodes.Dog)} items={dogs} loading={dloading} />
          </div>
        </FieldGroup>
        <FieldGroup columns={2} fieldsetProps={{ divider: false, title: t(ETLCodes.Competition) }}>
          <FGCountrySelect name="competitionCountryId" label={t(ETLCodes.Country)} />
          <FGSRSHDateMaskInput label={t(ETLCodes.Date)} name="competitionDate" />
          <FGTextInput label={t(ETLCodes.Points)} name="competitionPoints" />
          <FGTextInput name="competitionCity" label={t(ETLCodes.City)} />
          <FGTextInput name="competitionType" label={t(ETLCodes.Type)} />
          <FGTextInput name="competitionJudge" label={t(ETLCodes.Judge)} />
        </FieldGroup>
        <DrupalStepperButtonBloc backOnly />
      </DrupalFormGenerator>
    </>
  );
};
